import React from 'react';
import ReactDOM from 'react-dom';
import io from 'socket.io-client';
import store from 'store';
import moment from 'moment';
import Handlebars from 'handlebars';
import IncomingCall from './components/IncomingCall';
import VideoCall from './components/VideoCall';
import ContactMessage from './components/ContactMessage';

export default function connectToSocketServer() {
  const url = 'https://api.virtask.nl';
  // const url = 'http://localhost:4444';
  console.log('Connecting to Socket Server', url);
  const { key, secret } = store.get('credentials');
  const socket = io(url, {
    path: '/user/status',
    query: { key, secret },
    transports: ['websocket']
  });
  socket.on('connect', () => {
    console.log('Connected to Socket Server');
    if (window.NetworkStatus) window.NetworkStatus.hideError();
    delete window.authError;
    if (window.ContactsList) window.ContactsList.hideAuthError();
  });
  socket.on('auth_error', (error) => {
    console.error('Auth Error', error);
    window.authError = true;
    if (window.ContactsList) window.ContactsList.showAuthError();
  });
  socket.on('connect_error', (error) => {
    console.error('Socket Connection Error', error);
    if (window.NetworkStatus) window.NetworkStatus.showError();
  });
  socket.on('warning', (msg) => {
    console.error('Socket Warning', msg);
  });
  socket.on('error', (error) => {
    console.error('Socket Error', error);
  });
  socket.on('disconnect', () => {
    console.error('Socket Disconnected');
  });
  const onCall = (msg) => {
    console.log('Incoming Call', msg);
    if (window.VideoCall) {
      const locale = global.dictionaries.calling;
      socket.emit('user-busy', { email: msg.email });
      window.Notifications.add({
        datetime: new Date(),
        expires: moment().add(1, 'day').toDate(),
        icon: 'fa fa-phone',
        title: locale.missedCallTitle,
        content: Handlebars.compile(locale.missedCallBusy)({ personName: msg.name })
      });
    } else {
      ReactDOM.render(
        <IncomingCall
          socket={socket}
          name={msg.name}
          email={msg.email}
          picture={msg.picture}
        />,
        document.getElementById('incomingCall'));
    }
  };
  socket.on('call', onCall);
  socket.on('user-busy', (msg) => {
    console.log('User Busy', msg);
    ReactDOM.unmountComponentAtNode(document.getElementById('makingCall'));
    ReactDOM.render(
      <ContactMessage
        socket={socket}
        name={msg.name}
        msgKey="userBusy"
      />,
      document.getElementById('contactMessage'));
  });
  socket.on('call-timeout', (msg) => {
    console.log('Call Timeout', msg);
    ReactDOM.unmountComponentAtNode(document.getElementById('makingCall'));
    ReactDOM.render(
      <ContactMessage
        socket={socket}
        name={msg.name}
        msgKey="userNotAvailable"
      />,
      document.getElementById('contactMessage'));
  });
  socket.on('cancel-call', (msg) => {
    console.log('Cancel Call', msg);
    const locale = global.dictionaries.calling;
    ReactDOM.unmountComponentAtNode(document.getElementById('incomingCall'));
    window.Notifications.add({
      datetime: new Date(),
      expires: moment().add(1, 'day').toDate(),
      icon: 'fa fa-phone',
      title: locale.missedCallTitle,
      content: Handlebars.compile(locale.missedCallNotAvailable)({ personName: msg.name })
    });
  });
  socket.on('accept-call', (msg) => {
    console.log('Accept Call', msg);
    ReactDOM.unmountComponentAtNode(document.getElementById('makingCall'));
    ReactDOM.render(
      <VideoCall
        socket={socket}
        senderEmail={store.get('credentials').key}
        receiverEmail={msg.email}
        remoteUserName={msg.name}
        remoteUserEmail={msg.email}
      />,
      document.getElementById('videoCall'));
  });
  socket.on('hang-up', (msg) => {
    console.log('Hangup Call', msg);
    if (window.VideoCall) window.VideoCall.terminateCall();
  });
  return socket;
}



// WEBPACK FOOTER //
// ./src/connectToSocketServer.js